/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostChainAppNameRequestBodyTypename = "PostChainAppNameRequestBody" as const;

/**
 *
 * @export
 * @interface PostChainAppNameRequestBody
 */
export interface PostChainAppNameRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostChainAppNameRequestBody
   */
  appName: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostChainAppNameRequestBody
   */
  readonly __typename?: string;
}

export function PostChainAppNameRequestBodyFromJSON(json: any): PostChainAppNameRequestBody {
  return PostChainAppNameRequestBodyFromJSONTyped(json, false);
}

export function PostChainAppNameRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostChainAppNameRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostChainAppNameRequestBodyTypename,

    appName: json["app_name"],
  };
}

export function PostChainAppNameRequestBodyToJSON(object?: PostChainAppNameRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    app_name: value.appName,
  };
}
